import type { DashboardStats } from "../api/types";

interface StatsCardsProps {
  stats: DashboardStats;
  archiveTotal: number;
  todayNewArchives: number;
  deptCount: number;
}

export function StatsCards({ stats, archiveTotal, todayNewArchives, deptCount }: StatsCardsProps) {
  return (
    <section className="stats" aria-label="今日概览">
      <div className="stat-card">
        <div className="stat-icon blue" aria-hidden="true">
          🗓️
        </div>
        <div>
          <div className="num">{stats.total}</div>
          <div className="label">今日应开会议</div>
          <div className="sub">覆盖 {deptCount} 个部门 · 日/周/月会</div>
        </div>
      </div>
      <div className="stat-card">
        <div className="stat-icon green" aria-hidden="true">
          ✅
        </div>
        <div>
          <div className="num green">
            {stats.done}
          </div>
          <div className="label">已正常开启</div>
          <div className="sub">开启率 {stats.openRate}%</div>
        </div>
      </div>
      <div className="stat-card">
        <div className="stat-icon red" aria-hidden="true">
          ⚠️
        </div>
        <div>
          <div className="num red">
            {stats.missed}
          </div>
          <div className="label">未开启（需提醒）</div>
          <div className="sub">涉及 {stats.missedDepts.length} 个部门</div>
        </div>
      </div>
      <div className="stat-card">
        <div className="stat-icon purple" aria-hidden="true">
          🗂️
        </div>
        <div>
          <div className="num purple">
            {archiveTotal}
          </div>
          <div className="label">已归档会议纪要</div>
          <div className="sub">今日新增 {todayNewArchives} 份</div>
        </div>
      </div>
    </section>
  );
}
